import { useMutation } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';

/**
 * 마켓 즐겨찾기 추가 mutation.
 * 호출 측에서 native 동기화(bridge.favoriteMarket)와 optimistic update 를 책임진다.
 */
export const usePostFavoriteMarket = () => {
  return useMutation({
    mutationFn: favoriteMarketService.post,
  });
};
